export const ROUTE = {
  // DASHBOARD: {
  //   LINK: '/'
  // },
  // SETTING: {
  //   LINK: '/settings'
  // },
  // SETTING_MANAGE: {
  //   LINK: '/settings/manages'
  // },
  // DOCUMENT_COMPONENT: {
  //   LINK: '/document-component'
  // },
  HOME: {
    LINK: '/',
    NAME: 'home',
  },
  CONVERSATION: {
    LINK: '/conversation',
    NAME: 'conversation',
  },
  CONVERSATION_MANAGE: {
    LINK: '/conversation/[user_id]',
  },
  CONVERSATION_MANAGE_DETAIL: {
    LINK: '/conversation/[user_id]/[chat_id]',
  },
  PRESET: {
    LINK: '/preset',
  },
  PRESET_MANAGE: {
    LINK: '/preset/[id]',
  },
  APPLICATION: {
    LINK: '/access-management/application',
  },
  SCOPE: {
    LINK: '/access-management/scope',
  },
  USER: {
    LINK: '/access-management/user',
  },
  LOGIN: {
    LINK: '/login',
    NAME: 'login',
  },
};
